import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { Helmet } from 'react-helmet';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-kenya-white">
      <Helmet>
          <meta http-equiv="Content-Security-Policy" 
        content="default-src 'self';
                script-src 'self' 'unsafe-inline' 'unsafe-eval' https://www.google.com https://www.gstatic.com;
                script-src-elem 'self' https://www.google.com https://www.gstatic.com;
                style-src 'self' 'unsafe-inline' https://www.google.com https://www.gstatic.com;
                img-src 'self' data: https: http:;
                connect-src 'self' https://ipapi.co https://ipwho.is https://www.google.com https://kenyaindiasporapetition.com;
                frame-src 'self' https://www.google.com https://www.gstatic.com;
                font-src 'self' https://fonts.gstatic.com;" />
        <title>Kenyans in Diaspora Petition Against Bad Governance</title>
        <meta name="description" content="Join Kenyans worldwide in petitioning against bad governance" />
      </Helmet>
      
      <Navbar />
      
      <main className="flex-grow container mx-auto px-4 py-8">
        {children}
      </main>
      
      <Footer />
    </div>
  );
};

export default Layout;